// Fix indexOf for IE < 9.
if (!Array.prototype.indexOf) { 
  Array.prototype.indexOf = function(obj, start) {
    for (var i = (start || 0), j = this.length; i < j; i++) {
      if (this[i] === obj) { return i; }
    }
    return -1;
  }
}

// List of redirect sites and the countries to be sent there.
var redirects = {
  "http://usa.suecos.com": [
     
    // USA and Canada
    'US', 'CA', 'USA', 
  ]
    
 

}
;



function redirect(ip) {
  var xmlhttp;
  ip = (ip) ? ip : ""; // Default to blank string
  if (window.XMLHttpRequest) {
    // code for IE7+, Firefox, Chrome, Opera, Safari
    xmlhttp = new XMLHttpRequest();
  } else {
    // code for IE6, IE5
    xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
  }
  xmlhttp.onreadystatechange = function() {
    if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
      var response = JSON.parse(xmlhttp.response);
      for (var site in redirects) {
        if (redirects.hasOwnProperty(site)){
          if (redirects[site].indexOf(response.country_code) > -1) {
            window.location = site + window.location.pathname;
          }
        }
      }
    }
  };
  xmlhttp.open("GET", "http://freegeoip.net/json/" + ip, true);
  xmlhttp.send();
}
